import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { CollectTerminalStepNavigationProps } from './collect-terminal.types';
import { CollectTerminalGenericNavigation } from './navigation/collect-terminal-generic-navigation';

export const CollectTerminalNavigationSwitch = ({ body }: CollectTerminalStepNavigationProps) => {
  return <StepNavigationSwitch body={body} generic={CollectTerminalGenericNavigation} />;
};
